export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/hats.16ceccc.svg";